module.exports = __webpack_public_path__ + "img/ic_shipping_footer.54fa6930.svg";